import Hook from "../utils/hook"

// a site card: its save button opens the save modal, or the login wall when
// signed out (there's no `SiteSaveModal` then), and the card is `is-saved` while
// the site is saved somewhere
export default Hook(`SiteCard`, {
  refs: [`siteSaveModal`],
  targets: [`button`],
  values: { site: Number, saved: Boolean },
  actions: [{ name: `open`, target: `button`, type: `click` }],

  siteSaveModalRefMounted(ref) {
    ref.addCard(this)
  },

  siteSaveModalRefDestroyed(ref) {
    ref.removeCard(this)
  },

  destroyed() {
    if (this.siteSaveModalRef) this.siteSaveModalRef.removeCard(this)
  },

  openAction() {
    if (this.siteSaveModalRef) {
      this.siteSaveModalRef.open(this.siteValue)
      return
    }

    // rendered by the root layout, outside of this hook
    const loginWall = document.getElementById(`login-wall-modal`)
    if (loginWall)
      this.liveSocket.execJS(
        loginWall,
        loginWall.getAttribute(`data-modal-show`)
      )
  },
})
